import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Grid, Button } from '@material-ui/core'
import styles from './styles'
import GraphLineDot from "./GraphLineDot"
import QuizQuestion from './QuizQuestion'

const Graph = (props) => {
  const {
    classes,
    setAnswers,
    questionAnswer,
    nextQuestion,
    resetGraph,
    modalOpen,
  } = props


  const [answeredCorrectly, setAnsweredCorrectly] = useState(null)
  const [answeredCorrectlyStep2, setAnsweredCorrectlyStep2] = useState(null)
  const [moved, setMoved] = useState(null)
  const [submitted, setSubmitted] = useState(false)
  const [submitPart2, setSubmitPart2] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [dottedLineLabels, setDottedLineLabels] = useState(false)
  const [hideQuestionBeforeAnimation, setHideQuestionBeforeAnimation] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setHideQuestionBeforeAnimation(false)
    }, 500)
  }, [])

  useEffect(() => {
    if(answeredCorrectly !== null && answeredCorrectlyStep2 !== null)
      setAnswers((prevAnswers) => [...prevAnswers, {step1: answeredCorrectly, step2: answeredCorrectlyStep2}])
  }, [moved])

  const handleSubmit = () => {
    setSubmitted(true)
    // setSubmitPart2(0)
    questionAnswer.answer.includes('goes') && setTimeout(() => setDottedLineLabels(true), 1000)
  }

  const secondPart = () => {
    setSubmitPart2(1)

  }

  const secondPartSubmit = () => {
    // submitPart2(2)
    setAnswers((prevAnswers) => [...prevAnswers, {step1: answeredCorrectly, step2: questionAnswer.step2.answer === selectedOption}])
    setSubmitPart2(2)
    // nextQuestion()
  }

  return (
    <Grid container alignItems="center" direction="column">
      <Grid container item justify='center' alignItems='center'>
        <Grid style={{position: "relative", display: "flex", alignSelf: "flex-start"}}>
          <GraphLineDot
            questionAnswer={questionAnswer}
            setAnsweredCorrectly={setAnsweredCorrectly}
            answeredCorrectly={answeredCorrectly}
            setMoved={setMoved}
            modalOpen={modalOpen}
            submitted={submitted}
            dottedLineLabels={dottedLineLabels}
            key={resetGraph}
          />
            <Button
              onClick={submitted ? submitPart2 === 0 ? secondPart : submitPart2 === 1 ? secondPartSubmit : nextQuestion  : handleSubmit}
              className={submitted ? classes.nextButton : classes.submitButton}
            >
              {submitted ? submitPart2 === 0 ? "NEXT" : submitPart2 === 1 ? "SUBMIT" : "NEXT" : "SUBMIT"}
            </Button>
        </Grid>
        {hideQuestionBeforeAnimation
          ? <Grid className={classes.questionContainerHidden}/>
          : <QuizQuestion
              answeredCorrectly={answeredCorrectly}
              questionAnswer={questionAnswer}
              submitPart2={submitPart2}
              setAnsweredCorrectlyStep2={setAnsweredCorrectlyStep2}
              answeredCorrectlyStep2={answeredCorrectlyStep2}
              moved={moved}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
            />}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Graph)
